import { Box } from '@mui/material';
import React from 'react';
import { CancelButton, SubmitButton } from '../../../../components/mui/Buttons/Buttons';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { foodListBlockUnblock } from '../../../../redux/features/foodSlice';
const FoodFine = ({ employeeId, rowData, setFoodFineEmployeeId,setRowData,setApiTrigger }) => {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const submitAction = () => {
    dispatch(foodListBlockUnblock({ userIds: [employeeId], status: rowData?.food_availability >0 ? 0 : 1 })).then(
      (res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            setFoodFineEmployeeId(null);
            setRowData(null);
            setApiTrigger((prev)=>!prev)
          },
        });
      },
    );
  };
  return (
    <Box>
      Do you want to {`${rowData?.food_availability > 0 ? 'Unblock' : 'Block'}`} this user for food fine?
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <CancelButton
          action={() => {
            setFoodFineEmployeeId(null);
          }}
        >
          Cancel
        </CancelButton>
        <SubmitButton action={submitAction}>Submit</SubmitButton>
      </Box>
    </Box>
  );
};

export default FoodFine;
